/* eslint-disable parog-web/no-glint-expect-error-directive */
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import formatDate from 'ember-intl/helpers/format-date';
import eq from 'ember-truth-helpers/helpers/eq';
import type InsWithConfirmationRetrievalContext from 'parog-web/contexts/ins-with-confirmation-retrieval-context';
import Button from 'ui-kit/components/button';

interface Args {
  context: InsWithConfirmationRetrievalContext;
  onDismiss: () => void;
}

export default class InsRetrieveAccessFormConfirmIdentityComponent extends Component<Args> {
  onSubmit = async (event: Event): Promise<void> => {
    event.preventDefault();
    await this.args.context.transitionTo();
  };

  <template>
    <div data-test-confirm-identity>
      <form
        {{on 'submit' this.onSubmit}}
        class='ui form'
        id='ins-retrieve-access-form-confirm-identity'
      >

        <span>
          <b>
            Une identité a été récupérée à partir des serveurs INSi. Veuillez
            confirmer l'application de ces informations sur la fiche
            administrative du patient
          </b>
        </span>

        <table class='ui table'>
          <thead>
            <tr>
              <th>Matricule INS</th>
              <th>OID</th>
              <th>Nom de naissance</th>
              <th>Prénom(s) de naissance</th>
              <th>Date de naissance</th>
              <th>Sexe</th>
              <th>Code lieu de naissance (code INSEE)</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td
                data-test-ins-value
              >{{@context.identityResult.identity.value}}{{@context.identityResult.identity.key}}</td>
              <td
                data-test-ins-oid
              >{{@context.identityResult.identity.oid}}</td>
              <td
                data-test-ins-birth-name
              >{{@context.identityResult.birthName}}</td>
              <td
                data-test-ins-birth-given
              >{{@context.identityResult.birthGiven}}</td>
              <td data-test-ins-birthday>{{formatDate
                  @context.identityResult.birthday
                }}</td>
              <td data-test-ins-sex>
                {{#if (eq @context.identityResult.sex 'female')}}
                  Femme
                {{else}}
                  Homme
                {{/if}}
              </td>
              <td
                data-test-ins-birthplace
              >{{@context.identityResult.birthPlace}}</td>

            </tr>
          </tbody>
        </table>

        <div class='form-buttons'>
          <Button
            type='button'
            class='ui fluid form-button'
            {{! @glint-expect-error }}
            onclick={{@onDismiss}}
          >
            Annuler la récupération INS
          </Button>
          <Button
            data-test-button='submit-ins-confirm-identity'
            type='submit'
            class='ui fluid primary form-button'
          >
            Confirmer l'identité
          </Button>
        </div>
      </form>
    </div>
  </template>
}
